import {
  AirplaneTiltIcon,
  BankIcon,
  BriefcaseIcon,
  CarIcon,
  ChartLineUpIcon,
  CoinsIcon,
  CreditCardIcon,
  CurrencyDollarIcon,
  FirstAidIcon,
  FolderIcon,
  ForkKnifeIcon,
  GavelIcon,
  GiftIcon,
  GraduationCapIcon,
  HandSoapIcon,
  HandshakeIcon,
  HouseIcon,
  LaptopIcon,
  MoneyIcon,
  MusicNotesIcon,
  PawPrintIcon,
  PiggyBankIcon,
  ReceiptIcon,
  VaultIcon,
  WalletIcon,
  type Icon,
} from '@phosphor-icons/react';

const RULES: { match: RegExp; icon: Icon }[] = [
  // Liabilities / loans (specific first)
  { match: /credit\s?card/i, icon: CreditCardIcon },
  { match: /student\s?loan/i, icon: GraduationCapIcon },
  { match: /(auto|car)\s?loan/i, icon: CarIcon },
  { match: /mortgage|home\s?loan/i, icon: HouseIcon },
  { match: /personal\s?loan|line\s?of\s?credit|loan|debt|liabil/i, icon: ReceiptIcon },

  // Net worth & savings buckets
  { match: /emergency|reserve/i, icon: VaultIcon },
  { match: /retirement|401|403|ira|roth|pension|life\s?insurance/i, icon: BankIcon },
  { match: /cash|sinking/i, icon: MoneyIcon },
  { match: /invest|brokerage|stock|mutual|equity|etf|fund/i, icon: ChartLineUpIcon },
  { match: /crypto|coin|bitcoin|btc|eth|ethereum/i, icon: CoinsIcon },
  { match: /savings|piggy/i, icon: PiggyBankIcon },
  { match: /checking|bank|deposit/i, icon: BankIcon },
  { match: /wallet/i, icon: WalletIcon },

  // Budget categories
  { match: /food|beverage|grocery|grocer|restaurant|dining|drink|alcohol/i, icon: ForkKnifeIcon },
  { match: /pet/i, icon: PawPrintIcon },
  { match: /personal\s?care|luxer|self\s?care|beauty|cosmetic/i, icon: HandSoapIcon },
  { match: /technology|tech|internet|phone|software|app/i, icon: LaptopIcon },
  { match: /transportation|travel|flight|trip|vacation/i, icon: AirplaneTiltIcon },
  { match: /healthcare|medical|health|dental|vision/i, icon: FirstAidIcon },
  { match: /entertainment|music|movie|television|streaming/i, icon: MusicNotesIcon },
  { match: /work|business|education|llc|company/i, icon: BriefcaseIcon },
  { match: /legal|lawyer|attorney/i, icon: GavelIcon },
  { match: /gift/i, icon: GiftIcon },
  { match: /family|friend/i, icon: HandshakeIcon },

  // Property & vehicle (after budget so "Transportation & Travel" wins over "auto")
  { match: /real\s?estate|home|house|property|condo/i, icon: HouseIcon },
  { match: /vehicle|car|auto/i, icon: CarIcon },

  // Generic income labels
  { match: /salary|income|paycheck/i, icon: CurrencyDollarIcon },
];

export function getCategoryIcon(category: string): Icon {
  for (const rule of RULES) {
    if (rule.match.test(category)) return rule.icon;
  }
  return FolderIcon;
}
